export function estadoDocumentalPago(op) {
  if (op?.status !== "pagada") return null;
  const c = op.conciliacion_pago;
  if (c?.estado === "conciliado") return { label: "Pagada conciliada", cls: "bg-blue-100 text-blue-700 border-blue-200" };
  if (c?.monto_conciliado) return { label: "Pagada con alertas", cls: "bg-amber-100 text-amber-800 border-amber-300" };
  return { label: "Pago por conciliar", cls: "bg-amber-100 text-amber-800 border-amber-300" };
}
